import { render, staticRenderFns } from "./fileMaterial.vue?vue&type=template&id=3134cda6&"
import script from "./fileMaterial.vue?vue&type=script&lang=ts&"
export * from "./fileMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports